export class AppealStatusSearchResponseModel {
    constructor(data = {}) {
        this.isAppeal = data.isAppeal ?? null;
        this.appealStatus = data.appealStatus ?? null;
        this.appealOutcome = data.appealOutcome ?? null;
        this.iroAt = data.iroAt ?? null;
    }
}
